import { KanbanBoard, UnifiedKanbanCard } from "@/components/ui";

export const LeadKanban = ({ stages, filtered, isLoading, onLeadClick, updateStatus, onUpdateLead, teamMembers = [] }) => {
  const onItemMove = (lead, stageKey) => {
    updateStatus(lead, stageKey);
  };

  return (
    <KanbanBoard
      className="bg-slate-50/30"
      stages={stages}
      items={filtered}
      isLoading={isLoading}
      onItemMove={onItemMove}
      renderCard={(lead) => (
        <UnifiedKanbanCard 
          item={lead} 
          onClick={onLeadClick}
          onUpdate={onUpdateLead}
          teamMembers={teamMembers}
          variant="lead"
        />
      )}
    />
  );
};
